module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/194rXKi/images/9780825485619_cover.jpg?1685203881890",
      "alt": "This image is the cover for the book 40 Questions About the Historical Jesus, 40 Questions Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("40 Questions About the Historical Jesus, 40 Questions Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Answers to critical questions regarding the study of the Jesus of history and the Christ of faith")]), _c('br'), _c('br'), _vm._v("The conclusions of the quest for the historical Jesus, which casts the majority of Christ's life as a myth, are a stark contrast to the orthodox view of Christ as presented in the Bible. Pate demonstrates that a critical analysis of the gospel text along with historical and cultural methods of investigation actually point toward an orthodox view of Christ."), _c('br'), _c('br'), _vm._v("This work argues that the canonical Gospels are the most trustworthy information we have about the gospel writers as well as the life and ministry of Jesus, including his death, visit to hades, resurrection, and ascension. Readers will be encouraged by the reliability of the Gospel writers, the reality of Jesus' humanity and deity, and the inferiority of the apocryphal gospels.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      C. Marvin Pate\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("C. Marvin Pate (PhD, Marquette University) is professor of biblical studies at Ouachita Baptist University. He is the author and editor of numerous works, including "), _c('i', [_vm._v("Four Views on the Book of Revelation")]), _vm._v("; "), _c('i', [_vm._v("The Writings of John: A Survey of the Gospel, Epistles, and Apocalypse")]), _vm._v("; and "), _c('i', [_vm._v("From Plato to Jesus")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Kregel Publications\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0